import { Active, closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { Form, FormInstance, FormListFieldData } from 'antd';
import { SortableOverlay } from 'features/settingService/components/SortableList/SortableOverlay';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { QuickBookingV2ServiceItem, QuickBookingV2ServiceItemProps } from './ServiceItem';
import { IQuickBookingV2ServiceItem } from '../type';
type Props = {
  fields: FormListFieldData[];
  services?: IQuickBookingV2ServiceItem[];
  onReorder?: (value?: IQuickBookingV2ServiceItem[]) => void;
  onOpenChangeTime: (value: IQuickBookingV2ServiceItem) => void;
  onActiveService: QuickBookingV2ServiceItemProps['onActiveService'];
  form: FormInstance<any>;
  remove: (index: number) => void;
  isBookByService?: boolean;
  onOpenChangeStaff?: QuickBookingV2ServiceItemProps['onActiveService'];
};
const ServiceList = ({ form, fields, onReorder, onOpenChangeTime, onActiveService, services: items = [], remove, isBookByService, onOpenChangeStaff }: Props) => {
  const [active, setActive] = useState<Active | null>(null);
  const activeItem = useMemo(
    () => {
      const idx = items.findIndex((o) => o.id === active?.id);
      if (idx == -1) return null;
      return ({
        data: items[idx],
        idex: idx,
      });
    },
    [active, items, fields]
  );

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 50 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const handleActiveServices = (value: IQuickBookingV2ServiceItem) => {
    onActiveService?.(value, items);
  };

  return (
    <>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={({ active }) => {
          setActive(active);
        }}
        onDragEnd={({ active, over }) => {
          if (over && active.id !== over?.id) {
            const activeIndex = items.findIndex(({ id }) => id === active.id);
            const overIndex = items.findIndex(({ id }) => id === over.id);

            onReorder?.(arrayMove(items, activeIndex, overIndex));
          }
          setActive(null);
        }}
        onDragCancel={() => {
          setActive(null);
        }}
      >
        <SortableContext items={items}>
          {fields.map((o, i) => (
            <Form.Item key={o.key} noStyle name={o.name}>
              <QuickBookingV2ServiceItem
                name={o.name}
                onChangeTime={onOpenChangeTime}
                onActiveService={handleActiveServices}
                onOpenChangeStaff={onOpenChangeStaff}
                form={form}
                index={i}
                onRemove={() => remove(i)}
                isBookByService={isBookByService} />
            </Form.Item>
          ))}
          <SortableOverlay>
            {activeItem?.data ?
              <QuickBookingV2ServiceItem drag value={activeItem.data} index={activeItem.idex} isBookByService={isBookByService} />
              : null}
          </SortableOverlay>
        </SortableContext>
      </DndContext>
    </>
  );
};

export { ServiceList };
const CateWrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
`;